/* 
react-table install: 
    npm install react-table@7.8.0 
pakets install for sticky:
    npm i react-table-sticky
    npm install styled-components
    npm install react-icons
*/


import React, { useMemo, useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { useTable, useFilters, useRowSelect, useSortBy } from 'react-table'
import { ColumnFilter } from './ColumnFilter'
import { FaPen, FaCopy, FaFileInvoice } from 'react-icons/fa' // icons
import { FaSortAlphaDown, FaSortAlphaDownAlt } from 'react-icons/fa'
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaInfoCircle } from 'react-icons/fa'; // Info-Icon

import './BasicTable.css'


export const BasicTable = ({ columns, 
    accessor, 
    data, 
    handleButtonChange, 
    handleButtonCopy, 
    handleButtonDelete, 
    showDatasheet, 
    showImage, 
    clearFields, 
    isAnyIconClicked, 
    newSaveID, 
    showDatasheetIcon, 
    fetchDepartmentOptions, 
    fetchMachinetypeImageOptions, 
    fetchMachinetypeDatasheetOptions,
    fetchMachineConfigurationOptions, 
    fetchYarnOptions, 
    fetchYarnImageOptions, 
    fetchYarnDatasheetOptions,
    fetchBasicYarnOptions, 
    fetchBasicYarnImageOptions,
    fetchBasicYarnDatasheetOptions,
    canCreate, 
    canUpdate, 
    canDelete,
    handleIconContactingmethodClick, 
    hideFieldsContactingmethod, 
    handleIconClick }) => {
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [isChangeIconClicked, setIsChangeIconClicked] = useState(false);
    const [clickedIcon, setClickedIcon] = useState(null); // Zustandsvariable fuer ausgewaehltes Symbol
    const [stickyDatasheet, setStickyDatasheet] = useState(0);
    const [stickyChange, setStickyChange] = useState(0);
    const [stickyCopy, setStickyCopy] = useState(0);
    const [stickyDelete, setStickyDelete] = useState(0);

    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');

    const [readyToSelect, setReadyToSelect] = useState(false);
    const location = useLocation();
    const newCurrentPage = location.pathname;

    const isAdminPage = location.pathname === '/administration';
    const id_role = window.localStorage.getItem('id_role');
    const id_person = window.localStorage.getItem('id_person');


    // Setzt den Zustand, wenn beide Werte verfügbar sind
    useEffect(() => {
        if (data && newSaveID) {
            setReadyToSelect(true);
        }
    }, [data, newSaveID]);

    // Funktion zum Markieren des neuen Datensatzes in der Tabelle (newSaveID von Page)
    useEffect(() => {
        if (!readyToSelect) return; // Führe die Auswahl nur aus, wenn beide Werte bereit sind

        const selectRowByRowId = (newSaveID) => {
            // Prüfen, ob data verfügbar ist
            if (!data || data.length === 0) {
                console.warn('No data available to find the row.');
                return;
            }
            //const rowIndex = data.findIndex(row => row[accessor] === newSaveID);


            //const rowIndex = data.findIndex(row => String(row.original?.[accessor]) === String(newSaveID));
            //const rowIndex = data.findIndex(row => row.original?.id === newSaveID); // Passe `id` und Struktur an deine Daten an
            const rowIndex = data.findIndex(row => {
                const fieldValue = row[accessor]; // Direkter Zugriff, falls Daten flach sind
                return String(fieldValue) === String(newSaveID);
            });

            if (rowIndex !== -1) {              
                selectRow(rowIndex);
            } else {
                console.warn(`Row with ${accessor}=${newSaveID} not found.`);
            }
        };
        if (newSaveID && data && data.length > 0) {
            selectRowByRowId(newSaveID);
        }
    }, [newSaveID, data, accessor]);


    useEffect(() => {
        /* setzt die previousPage explizit, 
        da die Seite mehrmals aufgerufen wird und dann previousPage auch knittingmachinetype ist, 
        dadurch wird die Zeile nicht markiert*/
        setPreviousPage(window.localStorage.getItem('previousPage') || '');
        setCurrentPage(newCurrentPage);
    }, [newCurrentPage]);


    useEffect(() => {
        /* bei Seitenwechsel von machineconfiguration zurueck auf machinetype 
        wird die Zeilenmarkierung für Maschinentyp aufgefrischt*/
        if (data.length > 0 && currentPage === '/knittingmachinetype' && previousPage === '/knittingmachineconfiguration') {
            const idMachinetype = parseInt(window.localStorage.getItem('id_machinetype'), 10);

            // Funktion zum Markieren des Datensatzes in der Tabelle basierend auf der gespeicherten id_machinetype
            const selectRowByIdMachinetype = (idMachinetype) => {
                const rowIndex = data.findIndex(row => row[accessor] === idMachinetype);
                if (rowIndex !== -1) {
                    selectRow(rowIndex);
                } else {
                    console.error('Row with id', idMachinetype, 'not found.');
                }
            };
            selectRowByIdMachinetype(idMachinetype)
        }
    }, [currentPage, previousPage, accessor, data]);


    useEffect(() => {
        /* useEffect ueberwacht Aenderungen vom Klick auf change-icon und currentPage 
        fuehrt Anweisungen direkt aus und nicht mit Verzoegerung!!!
        Wenn isChangeIconClicked auf false gesetzt wurde, leere die Eingabefelder 
        und verberge die zusaetzlichen Eingabefelder auf der Seite ContactingrecipePage*/
        if (!isChangeIconClicked) {
            clearFields();  
            if (currentPage === '/contactingrecipe') { // TODO: funktioniert nicht
                hideFieldsContactingmethod();
            }
        }
    }, [isChangeIconClicked, currentPage]);


    // Funktionen, um die Icons Copy oder Datenblatt wieder zurückzusetzen (blau), wenn das New popup geschlossen wird
    useEffect(() => {
        // Ueberprüfen, ob das Icon geklickt wurde
        if (clickedIcon === 'copy' || 'datasheet') {
            isAnyIconClicked = true;
        } else  {
            isAnyIconClicked = false;
        }
    }, [clickedIcon]);
  
    
    useEffect(() => {
        // Ueberpruefen, ob das geklickte Symbol zurueckgesetzt werden soll
        if (!isAnyIconClicked && (clickedIcon === 'copy' || 'change' || 'datasheet' || 'delete')) {
            setClickedIcon(null); // Setze das Kopiersymbol wieder auf null (blau)
        }
    }, [isAnyIconClicked, clickedIcon]);  


    useEffect(() => {
        // Funktion zur Positionierung der icons nach Rollen wird aufgerufen
        determineStickyIndices();
    }, [canUpdate, canCreate, canDelete]);
    

    // Standardspalte für Filterung, um nicht jede Spalte einzeln in columns.js zu filtern
    const defaultColumn = useMemo(() => {
        return {
            Filter: ColumnFilter
        };
    }, []);


    // Funktion, um die Anzahl der benutzten Maschinentypen in Rezepten darzustellen (bei 0 = leer)
    const modifiedColumns = useMemo(() => columns.map(column => {
        if (column.accessor === 'count_in_recipe') { 
            return {
                ...column,
                Cell: ({ value }) => (value === 0 ? '' : value)
            };
        }
        return column;
    }), [columns]);
    

    // Funktion zur Bestimmung der Sticky-Indizes
    const determineStickyIndices = () => {
        // Initialisieren der Sticky-Positionen
        let stickyDatasheet, stickyChange, stickyCopy, stickyDelete;

        // Festlegen der Sticky-Positionen basierend auf verschiedener Rollen
        if (canUpdate && canCreate && canDelete) {
            setStickyDatasheet(60); // Variable Position
            setStickyChange(40);
            setStickyCopy(20);
            setStickyDelete(0);
        } else if (canUpdate && canCreate) {
            setStickyDatasheet(40); 
            setStickyChange(20);
            setStickyCopy(0);
        } else if (canUpdate) {
            setStickyDatasheet(20); 
            setStickyChange(0);
        } else if (canCreate) {
            setStickyDatasheet(20); 
            setStickyCopy(0);
        } else {
            setStickyDatasheet(0);
        }
        return { stickyDatasheet, stickyChange, stickyCopy, stickyDelete };
    };


    // das geklickte Icon wird gesetzt
    const onIconClick = (icon) => {
        setClickedIcon(icon);
        // auf ContactingrecipePage wird es weitergegeben mittels Callback-Funktion, 
        // um die zusaetzlichen Eingabefelder für contactingmethod nur bei Klick auf change anzuzeigen
        if (currentPage === '/contactingrecipe') {
            handleIconClick(icon);
        }
    };


    // allgemeine Spaltenkonfiguration für die Buttons
    const extendedColumns = useMemo(() => {
        let cols = [...modifiedColumns];

        // Kontaktierungsmethode mit FaInfoCircle Icon hinzufügen (i)
        cols = cols.map(col => {
            if (col.accessor === 'contactingmethod_name') {
                return {
                    id: 'contactingmethod',
                    accessor: 'contactingmethod_name',
                    ...col,                   
                    Cell: ({ row, value }) => (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',             
                            zIndex: 1, // z-Index niedriger als fixierte Spalten
                            position: 'relative', // Wichtig für z-Index
                            }}>
                            <span>{value}</span> {/* Text linksbuendig */}
                            {/* wenn die Kontaktierungsmethode nicht freigegeben wurde (fremde Institution), 
                                erscheint auch das icon nicht*/}
                            {value && (
                                // TODO: bei onClick faerbt sich icon nicht rot
                                <FaInfoCircle className={`icon ${selectedRowIndex === row.index && clickedIcon === 'contactingmethod' ? 'icon-clicked' : ''}`}
                                    style={{ marginLeft: 'auto', cursor: 'pointer' }}                                
                                    onClick={(e) => {
                                        setSelectedRowIndex(row.index);  
                                        onIconClick('contactingmethod');                              
                                        handleIconContactingmethodClick(row.original.id_contactingrecipe, value);
                                    }}
                                />
                            )}
                        </div>
                    ),
                };
            }
            return col;
        });

        if (showDatasheetIcon) {
            cols.push({
                id: 'datasheet',
                accessor: row => row[accessor],
                disableFilters: true,
                Cell: ({ row, value }) => (                 
                    <div>
                        <FaFileInvoice className={`icon ${selectedRowIndex === row.index && clickedIcon === 'datasheet' ? 'icon-clicked' : ''}`} 
                            onClick={(e) => {
                                e.stopPropagation();
                                setSelectedRowIndex(row.index);
                                onIconClick('datasheet');
                                showDatasheet(value);
                                showSelectedImage(row.original);
                            }}
                        />
                    </div>
                ),
                sticky: `right right-${stickyDatasheet}`, // Dynamische Sticky-Position
            });
        }

        // nur bei eigener Institution werden Funktionen für change und copy ausgefuehrt und das icon deaktiviert
        // nur, wer updaten darf, bekommt das icon angezeigt
        if (isAdminPage || canUpdate) {
            cols.push({
                id: 'change',
                accessor: row => row[accessor],
                disableFilters: true,
                Cell: ({ row, value }) => {
                    // auf der UserAdministrationPage und wenn der Admin eingeloggt ist (id_role==1) ist das icon aktiviert
                    const canChangePerson = row.original['can_change_person'];

                    const isDisabled = (isAdminPage && !canChangePerson) || 
                        (isAdminPage || id_role == 1 
                         ? false 
                         : (row.original['count_in_recipe'] !== 0 && row.original['count_in_recipe'] !== undefined) 
                         || !row.original['self_id_institution']);


                    return (
                        <div>
                            <FaPen 
                                className={`icon ${selectedRowIndex === row.index && clickedIcon === 'change' ? 'icon-clicked' : ''} ${isDisabled ? 'icon-disabled' : ''}`} 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!isDisabled) {
                                        setSelectedRowIndex(row.index);
                                        setIsChangeIconClicked(true);                                   
                                        onIconClick('change');
                                        handleButtonChange(value); 
                                        showSelectedImage(row.original); 
                                        // Nur aufrufen, wenn die aktuelle Seite `knittingmacchinetype` ist
                                        if (currentPage === '/knittingmachinetype') {
                                            // extrahiert den institution_name aus der Zeile
                                            const institutionName = row.original['institution_name'];
                                            fetchDepartmentOptions(institutionName);
                                            fetchMachinetypeImageOptions(institutionName);
                                            fetchMachinetypeDatasheetOptions(institutionName);                                                 
                                        }
                                        // Nur aufrufen, wenn die aktuelle Seite `contactingrecipe` ist
                                        if (currentPage === '/contactingrecipe') {
                                            const institutionName = row.original['institution_name'];
                                            fetchMachineConfigurationOptions(institutionName);
                                            fetchYarnOptions(institutionName);
                                            fetchBasicYarnOptions(institutionName);
                                        }

                                        // Nur aufrufen, wenn die aktuelle Seite `yarn` ist
                                        if (currentPage === '/yarn') {
                                            const institutionName = row.original['institution_name'];
                                            fetchYarnImageOptions(institutionName); 
                                            fetchYarnDatasheetOptions(institutionName);                                            
                                        }

                                        // Nur aufrufen, wenn die aktuelle Seite `basicyarn` ist
                                        if (currentPage === '/basicyarn') {
                                            const institutionName = row.original['institution_name'];
                                            fetchBasicYarnImageOptions(institutionName);   
                                            fetchBasicYarnDatasheetOptions(institutionName);                                         
                                        }
                                    }
                                }}
                            />
                        </div>
                    );
                },
                sticky: `right right-${stickyChange}`, // Dynamische Sticky-Position
            });
        }
        // nur bei eigener Institution werden Funktionen für change und copy ausgefuehrt und das icon deaktiviert
        // Das copy Icon wird nur angezeigt, wenn die aktuelle Seite nicht die Benutzerverwaltung ist und die Rolle das update erlaubt
        if (!isAdminPage && canCreate) {
            cols.push({
                id: 'copy',
                accessor: row => row[accessor],
                disableFilters: true,
                Cell: ({ row, value }) => {
                    let isDisabled = false
                    if (id_role > 1) {
                        isDisabled = !row.original['self_id_institution'];
                    }
                    
                    return (
                        <div>
                            <FaCopy className={`icon ${selectedRowIndex === row.index && clickedIcon === 'copy' ? 'icon-clicked' : ''} ${isDisabled ? 'icon-disabled' : ''}`} 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (!isDisabled) {
                                        setSelectedRowIndex(row.index);
                                        onIconClick('copy');
                                        handleButtonCopy(value);
                                        showSelectedImage(row.original);
                                        if (currentPage === '/knittingmachinetype') {
                                            const institutionName = row.original['institution_name'];
                                            fetchDepartmentOptions(institutionName);
                                            fetchMachinetypeImageOptions(institutionName);
                                            fetchMachinetypeDatasheetOptions(institutionName);                                                 
                                        }
                                        if (currentPage === '/contactingrecipe') {
                                            const institutionName = row.original['institution_name'];
                                            fetchMachineConfigurationOptions(institutionName);
                                            fetchYarnOptions(institutionName);
                                            fetchBasicYarnOptions(institutionName);
                                        }
                                        if (currentPage === '/yarn') {
                                            const institutionName = row.original['institution_name'];
                                            fetchYarnImageOptions(institutionName); 
                                            fetchYarnDatasheetOptions(institutionName);                                            
                                        }
                                        if (currentPage === '/basicyarn') {
                                            const institutionName = row.original['institution_name'];
                                            fetchBasicYarnImageOptions(institutionName);   
                                            fetchBasicYarnDatasheetOptions(institutionName);                                         
                                        }
                                    }
                                }} 
                            />
                        </div>
                    );
                },
                sticky: `right right-${stickyCopy}`, // Dynamische Sticky-Position
            });
        };
        if (id_role==1) {
            cols.push({
                id: 'delete',
                accessor: row => row[accessor],
                disableFilters: true,
                Cell: ({ row, value }) => {                 
                    const canChangePerson = row.original['can_change_person'];
                    const isCurrentUser = row.original['id_person'] == id_person;  // Vergleich mit der ID des eingeloggten Benutzers

                    const isDisabled = (isAdminPage && !canChangePerson) || 
                        isCurrentUser ||
                        (isAdminPage
                        ? false 
                        : (row.original['count_in_recipe'] !== 0 && row.original['count_in_recipe'] !== undefined) 
                        || (row.original['machine_configuration_count'] !== 0 && row.original['machine_configuration_count'] !== undefined));

                    return (
                        <div>
                            <RiDeleteBin6Line className={`icon ${selectedRowIndex === row.index && clickedIcon === 'delete' ? 'icon-clicked' : ''} ${isDisabled ? 'icon-disabled' : ''}`} 
                                onClick={(e) => {
                                    e.stopPropagation(); // keine Weitergabe
                                    if (!isDisabled) {
                                        setSelectedRowIndex(row.index);
                                        onIconClick('delete');
                                        handleButtonDelete(value);
                                        showSelectedImage(row.original);
                                    }
                                }} 
                            />
                        </div>
                    );
                },
                sticky: `right right-${stickyDelete}`, // Dynamische Sticky-Position
            });
        }
        return cols;
    }, [modifiedColumns, accessor, handleButtonChange, handleButtonCopy, showDatasheet, clickedIcon, showDatasheetIcon]);

    
       
    // Funktion zum Anzeigen des Bildes des aktuellen Datensatzes (auch für machine_configuration)
    const showSelectedImage = (selectedRowData) => {
        // Machinetype und Yarn brauchen den filename, Machineconfiguration die id_machinetyp
        const institutionName = selectedRowData.institution_name;
        const imageName = selectedRowData.filename || '';
        const machinetypeName = selectedRowData.machinetype_name || '';

        if (accessor === 'id_machinetype' || accessor === 'id_yarn' || accessor === 'id_basic_yarn') {           
            showImage(imageName, machinetypeName, institutionName);
        }   
        else if (accessor === 'id_machine_configuration') {
            // machine_configuration hat weder den institutionName noch den filename-alles über id_machinetype ermitteln
            const idMachinetype = selectedRowData.id_machinetype || '';
            showImage(imageName, idMachinetype, institutionName);
        } else {
            // Auf anderen Seiten wird showImage nicht aufgerufen
            console.log('showImage wird nicht aufgerufen auf Seite');
        }
    }
    

    // Funktion zum Setzen der aktuellen Zeile (beim Anklicken)
    const selectRow = (row) => {
        // Prüfen, ob row direkt die Zeilennummer ist
        const rowIndex = typeof row === 'number' ? row : row?.index;

        // Schutz: Sicherstellen, dass rowIndex gültig ist
        if (rowIndex === undefined || rowIndex < 0 || rowIndex >= data.length) {
            console.error('Invalid rowIndex:', rowIndex);
            return;
        }

        // Zeilen-Daten aus data basierend auf rowIndex extrahieren
        const selectedRowData = data[rowIndex];

        // Zustand für visuelles Feedback setzen
        setSelectedRowIndex(rowIndex);

        setClickedIcon(null); // setzt den Zustand des geklickten Symbols auf null, wenn in die Zeile geklickt wird
        setIsChangeIconClicked(false);    

        showSelectedImage(selectedRowData); // Aufruf Funktion zum Anzeigen des Bildes der aktuellen Zeile

        // Spezifischen Wert (z. B. id_machinetype) im LocalStorage speichern
        const id_machinetype = selectedRowData?.id_machinetype;
        if (id_machinetype) {
            window.localStorage.setItem('id_machinetype', id_machinetype);
        } else {
            console.warn('id_machinetype not found in selected row data.');
        }
    };


    // Requisiten für die Tabelle
    const {
        getTableProps, 
        getTableBodyProps, 
        headerGroups, 
        rows, 
        prepareRow,
        } = useTable(
            {
                columns: extendedColumns,
                data,
                defaultColumn,
                initialState: {
                    selectedRowIds: { [selectedRowIndex]: true }
                },
                state: state => ({
                    ...state,
                    selectedRowIds: selectedRowIndex !== null ? { [selectedRowIndex]: true } : {}
                })
            },
            useFilters,
            useSortBy,
            useRowSelect          
        )


  return (
    <>
    <div className={currentPage === '/administration' ? 'admin-table-container' : 'table-container'}>
        <table {...getTableProps()} className='sticky'>
            <thead className='sticky'>
                {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map( column => (
                        <th {...column.getHeaderProps()} className={column.sticky ? `sticky-${column.sticky}` : ''}>
                            <div onClick={column.getSortByToggleProps().onClick}>
                                <span>
                                    {column.render('Header')}
                                    {column.isSorted ? (column.isSortedDesc ? <FaSortAlphaDownAlt style={{ marginLeft: '5px' }} />
                                    : <FaSortAlphaDown style={{ marginLeft: '5px' }} />) : ''}
                                </span>
                            </div>
                            <div>
                                {column.canFilter ? column.render('Filter') : null}
                            </div>
                        </th>
                    ))}                   
                    
                </tr>
                ))}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map((row) => {
                    prepareRow(row);
                    // Ueberpruefen, ob die Zeile ausgewaehlt ist und CSS-Klasse hinzufuegen
                    const isSelected = selectedRowIndex === row.index;                   
                    return (
                        <tr {...row.getRowProps()} 
                            className={isSelected ? 'selected-row' : ''}
                            onClick={() => selectRow(row)} // Übergeben der gesamten Zeile an `selectRow`
                        >
                            {row.cells.map((cell) => {
                                // bei fixierter Zelle:
                                const isStickyCell = cell.column.sticky;
                                // Wenn die Zelle fixiert ist und die Zeile ausgewaehlt ist, fuege die Klasse 'selected-row' hinzu
                                const cellClassName = isStickyCell && isSelected ? 'selected-row' : '';
                                return <td {...cell.getCellProps()} className={`${cell.column.sticky ? `sticky-${cell.column.sticky}` : ''} ${cellClassName}`}>{cell.render('Cell')}</td>
                            })}
                        </tr>
                    )
                })}
            </tbody>
        </table> 
    </div>
    </>
  )
}

export default BasicTable
